import { render, staticRenderFns } from "./SliceBody.vue?vue&type=template&id=0f567aa4&lang=pug&"
import script from "./SliceBody.vue?vue&type=script&lang=js&"
export * from "./SliceBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports